import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationsApi } from '../infrastructure/notifications.api';
import { notificationKeys } from './notifications.query';

function useNotificationInvalidation() {
  const client = useQueryClient();
  return () => client.invalidateQueries({ queryKey: notificationKeys.all });
}

export function useMarkNotificationReadCommand() {
  const invalidate = useNotificationInvalidation();
  return useMutation({
    mutationFn: (notificationId: string) => notificationsApi.markRead(notificationId),
    onSuccess: () => void invalidate(),
  });
}

export function useMarkAllNotificationsReadCommand() {
  const invalidate = useNotificationInvalidation();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => void invalidate(),
  });
}
